import React, { useContext, useEffect, useState } from "react";
import ReactHtmlParser from 'react-html-parser';

import { CompareToolBarContext } from '../sections/CompareToolBar/CompareToolBarContext';
import checkIcon from '../../images/WhiteCheckMark.png';

import { CheckBox, CompareCheckWrapper, CompareLabel, CompareText } from "./styles";

interface Props {
  phone: Record<string, any>;
  compareText: any;
}
const PhoneCompareButton = ({ phone, compareText }: Props) => {
  const [isAlreadySelected, setIsAlreadySelected] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const { selectedPhones, addPhone, removePhone } = useContext(CompareToolBarContext);
  useEffect(() => {
    const updatedSelection = !!selectedPhones.find(
      (mobilePhone) => mobilePhone.urlSlug === phone.urlSlug,
    );
    setIsAlreadySelected(
      updatedSelection,
    );
    setIsDisabled(!updatedSelection && selectedPhones.length >= 3);
  }, [selectedPhones, phone.urlSlug]);
  return (
    <CompareCheckWrapper>
      <CompareLabel htmlFor={phone.urlSlug} disabled={isDisabled}>
        <input
          id={phone.urlSlug}
          className="compareCheckbox"
          type="checkbox"
          checked={isAlreadySelected}
          onChange={() => isAlreadySelected
            ? removePhone(phone)
            : addPhone(phone)}
          disabled={isDisabled}
        />
        <div className="focusWrapper">
          <CheckBox
            data-testid="compare-checkbox"
            className={`customCheckbox ${
              isAlreadySelected && 'checked'
            }`}
          >
            {isAlreadySelected && <img src={checkIcon} alt="" />}
          </CheckBox>
          <CompareText data-testid="add-to-compare">
            {ReactHtmlParser(compareText)}
          </CompareText>
        </div>
      </CompareLabel>
    </CompareCheckWrapper>
  );
};

export default PhoneCompareButton;
